var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApproachable = function SvgApproachable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 433,
    height: 400,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#approachable_svg__a)",
    d: "M143.295 346.821c36.636-.177 73.183-14.225 101.125-42.145 56.285-56.238 56.285-147.397 0-203.634L143.295 0 42.213 101.042c-56.284 56.237-56.284 147.396 0 203.634 27.943 27.92 64.49 41.924 101.082 42.145"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#approachable_svg__b)",
    d: "M289.705 53.179c-36.636.177-73.183 14.225-101.125 42.145-56.285 56.237-56.285 147.397 0 203.634L289.705 400l101.082-101.042c56.284-56.237 56.284-147.396 0-203.634-27.943-27.92-64.49-41.924-101.082-42.145"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "approachable_svg__a",
    x1: 163.228,
    x2: 169.525,
    y1: 5.489,
    y2: 423.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FF4300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B35DFF",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "approachable_svg__b",
    x1: 269.772,
    x2: 256.305,
    y1: 394.511,
    y2: -23.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FF4300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B35DFF",
    stopOpacity: 0.6
  })))));
};
export default SvgApproachable;